/**
 * Every path in one place, so a rename is one edit rather than a grep.
 *
 * `as const` matters: it makes these string literals rather than `string`, so a
 * typo in a <Link to={...}> is a compile error.
 */
export const ROUTES = {
  home: '/',
  login: '/login',
  dashboard: '/dashboard',
  customers: '/customers',
  newCustomer: '/customers/new',
  customerDetail: (id: string) => `/customers/${id}`,
  audit: '/audit',
  security: '/security',
} as const;

/** Reachable without a session. Everything else redirects to login. */
export const PUBLIC_ROUTES: string[] = [ROUTES.login];
